<!-- src/app/pages/issues/issues.component.html -->
<section class="issues-page">

  <!-- HERO HEADER -->
  <div class="issues-hero">
    <div class="issues-hero__content">
      <div class="issues-eyebrow">Lydia's Platform</div>
      <h1>Lydia's Issues</h1>
      <p class="issues-intro">
        Inspired by Michigan's waterfalls, Lydia fights for a state where
        opportunity flows freely for all.
      </p>
      <p class="issues-disclaimer">
        Policies on this page are living documents. Lydia updates them as research, legislation, and community input evolve. If something here should be sharper, more accurate, or missing entirely, <a routerLink="/contact">tell her campaign</a>.
      </p>
    </div>
  </div>

  <!-- SECTION JUMP NAV -->
  <nav class="issues-jump-nav" *ngIf="groupedIssues.length > 0" aria-label="Jump to issue section">
    <div class="container issues-jump-nav__inner">
      <a
  *ngFor="let section of groupedIssues"
  class="issues-jump-nav__link"
  [routerLink]="[]"
  [fragment]="'section-' + section.key"
>
  {{ section.title }}
</a>
    </div>
  </nav>

  <!-- ISSUES GRID -->
  <div class="issues-body">
    <div class="container">

      <div *ngIf="loading" class="issues-empty">
        <p>Loading all issues...</p>
      </div>

      <div *ngIf="!loading && issues.length === 0" class="issues-empty">
        <p>No issues available at the moment.</p>
      </div>

      <div *ngFor="let section of groupedIssues" class="issues-section" [id]="'section-' + section.key">
        <h2 class="issues-section__title">{{ section.title }}</h2>

        <div class="issues-grid">
          <a
            class="issue-card"
            *ngFor="let issue of section.issues"
            [routerLink]="['/issues', issue.slug]"
          >
            <span class="issue-card__flag" *ngIf="isOptInFlagIssue(issue)">Opt-In, Not Out</span>
            <div class="issue-card__img" *ngIf="issue.image">
              <img
                [src]="issue.image"
                [alt]="issue.title + ' illustration'"
                loading="lazy"
              />
              <div
                class="issue-card__attribution"
                *ngIf="issue.attributionText && issue.attributionLink"
              >
                <a
                  [href]="issue.attributionLink"
                  target="_blank"
                  rel="noopener noreferrer"
                  (click)="$event.stopPropagation()"
                >{{ issue.attributionText }}</a>
              </div>
            </div>
            <div class="issue-card__body">
              <h2>{{ issue.title }}</h2>
              <p *ngIf="issue.summary">{{ issue.summary }}</p>
              <span class="issue-card__cta">Read More</span>
            </div>
          </a>
        </div>
      </div>

    </div>
  </div>

  <button
    *ngIf="showBackToTop"
    class="issues-back-to-top"
    (click)="scrollToTop()"
    aria-label="Return to top"
  >
    <svg viewBox="0 0 20 20"><path d="M5 12l5-5 5 5" /></svg>
  </button>

</section>
